import { Diamond } from "lucide-react";

const ITEMS = [
  "999.9 Fine Gold — $120.00 / g",
  "500 g Bar — $60,000",
  "1 kg Bar — $120,000",
  "2.5 kg Bar — $300,000",
  "5 kg Bar — $600,000",
  "10 kg Bar — $1,200,000",
  "12.5 kg Good Delivery — $1,500,000",
  "Minimum Wholesale Order — 500 g",
  "Monrovia Sales Headquarters",
];

const Row = ({ ariaHidden = false }) => (
  <div aria-hidden={ariaHidden} className="flex shrink-0 items-center">
    {ITEMS.map((item, i) => (
      <span key={i} className="flex items-center shrink-0">
        <span className="px-8 font-mono text-xs sm:text-sm tracking-[0.14em] uppercase whitespace-nowrap text-[#1A1816]/80">
          {item}
        </span>
        <Diamond size={8} className="text-[#C5A059] fill-[#C5A059] shrink-0" />
      </span>
    ))}
  </div>
);

const MarqueeTicker = () => (
  <div data-testid="price-marquee" className="relative border-y border-[#E6E0D4] bg-[#F3EFE6] py-4 overflow-hidden marquee">
    <div className="marquee-track flex w-max">
      <Row />
      <Row ariaHidden />
    </div>
  </div>
);

export default MarqueeTicker;
